var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLkdIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.89,0H11.11A11.11,11.11,0,0,0,0,11.11V188.89A11.12,11.12,0,0,0,11.11,200H188.89A11.11,11.11,0,0,0,200,188.89V11.11A11.1,11.1,0,0,0,188.89,0ZM65,160H40V75H65ZM52.42,65h-.14C44.83,65,40,59.44,40,52.49S45,40,52.57,40,64.86,45.4,65,52.5C65,59.44,60.17,65,52.42,65ZM160,160H135V114.51c0-11-6.13-18.49-16-18.49-7.5,0-11.56,5.06-13.54,10-.71,1.74-.5,6.58-.5,9v45H80V75h25V88.08C108.61,82.5,114.25,75,128.69,75,146.58,75,160,86.25,160,111.37Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLkdIcon);
export default __webpack_public_path__ + "static/media/lkd_icon.37c01ba6c4910647f0287b19a94ccf43.svg";
export { ForwardRef as ReactComponent };